import { Controller } from "@hotwired/stimulus"

// The coffret detail of the « + Coffret » dialog (card 11, the duo): « Coffret seul » or « Offre
// duo », and the family and duration pills. Every price is rendered by the server on the radios;
// this only shows the chosen family's durations and reads the price and label of the checked card,
// so the message typed in the form is never lost nor sent in a URL. A BD card prints at most
// noteMaxLines lines: the browser refuses a longer message before it is sent (the server refuses it
// too, but its answer re-renders the cart and the typed message would be lost).
// No optional chaining: Webpacker 5 does not transpile it.
export default class extends Controller {
  static targets = ["modeButton", "single", "duo", "durations", "price", "cardLabel", "note"]
  static values = { noteMaxLines: Number, noteLinesMessage: String }

  mode(event) {
    const duo = event.currentTarget.dataset.mode === "duo"
    this.modeButtonTargets.forEach((button) => {
      const on = (button.dataset.mode === "duo") === duo
      button.classList.toggle("on", on)
      button.setAttribute("aria-pressed", on ? "true" : "false")
    })
    if (this.hasSingleTarget) this.singleTarget.hidden = duo
    if (this.hasDuoTarget) this.duoTarget.hidden = !duo
  }

  // A new family starts on its default duration, as in the demo.
  family(event) {
    const kubeType = event.currentTarget.value
    this.durationsTargets.forEach((group) => {
      const shown = group.dataset.family === kubeType
      group.hidden = !shown
      if (!shown) return

      const pick = group.querySelector('input[data-default="true"]') || group.querySelector("input")
      if (pick) pick.checked = true
    })
    this.sync()
    this.checkNote()
  }

  checkNote() {
    if (!this.hasNoteTarget) return

    const family = this.element.querySelector('input[name="duo_family"]:checked')
    const lines = this.noteTarget.value.trim().split("\n").length
    const tooLong = family !== null && family.value === "bd" && lines > this.noteMaxLinesValue
    this.noteTarget.setCustomValidity(tooLong ? this.noteLinesMessageValue : "")
  }

  sync() {
    const checked = this.element.querySelector('input[name="card_id"]:checked')
    if (!checked) return

    if (this.hasPriceTarget) this.priceTarget.textContent = checked.dataset.price
    if (this.hasCardLabelTarget) this.cardLabelTarget.textContent = checked.dataset.label
  }
}
